import { render, staticRenderFns } from "./DetailedPurchaseModal.vue?vue&type=template&id=7d35b20e&scoped=true&"
import script from "./DetailedPurchaseModal.vue?vue&type=script&lang=js&"
export * from "./DetailedPurchaseModal.vue?vue&type=script&lang=js&"
import style0 from "./DetailedPurchaseModal.vue?vue&type=style&index=0&id=7d35b20e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d35b20e",
  null
  
)

export default component.exports